export const en = {
    action_delete: 'Delete',
    info: 'Once the transaction is deleted, it cannot be restored',
    title: 'Delete transaction',
};
